import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { BloodGasSampleAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
	selector: 'app-blood-gas-sample-slot',
	templateUrl: './blood-gas-sample-slot.component.html',
	styleUrls: ['./blood-gas-sample-slot.component.scss'],
	imports: [TickValueComponent],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class BloodGasSampleSlotComponent implements SheetSlotComponentBase {

	@Input() action!: BloodGasSampleAction;
	value = null;

	constructor() {
	}
}